import { AddressesLoading } from '@/components/loaders'
import { getUserAddresses, verifyUser } from '@/lib'
import { Address } from '@/types'
import { usePageBackground } from '@/hooks/use-page-background'
import { useEffect, useState } from 'react'
import { AddressesClient } from '../profile/addresses/client-page'
import { ButtonLink, FixedFooter } from "@/components/ui"


export function Addresses() {
  const [addresses, setAddresses] = useState<Address[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function loadData() {
      try {
        await verifyUser()
        const userAddresses = await getUserAddresses()
        setAddresses(userAddresses)
      } catch (error) {
        console.error('Error loading addresses:', error)
      } finally {
        setLoading(false)
      }
    }
    loadData()
  }, [])

  usePageBackground()

  if (loading) return <AddressesLoading />

  return (
    <>
      <AddressesClient addresses={addresses} />
      <FixedFooter>
        <ButtonLink to="/profile/addresses/new" size="lg" fullWidth>
          Cadastrar novo endereço
        </ButtonLink>
      </FixedFooter>
    </>
  )
}
